// extracted by mini-css-extract-plugin
export default {"container":"LockedReason_container__A1oCN","message":"LockedReason_message__uM4ff","text":"LockedReason_text__z-q5S"};